import { Injectable } from '@angular/core';
import { FunctionResult } from "@nova/common-interfaces";

@Injectable({
  providedIn: 'root',
})
export class PublicService {

  constructor() {
  }

  async saveContactInfo(): Promise<FunctionResult<boolean>> {
    return Promise.reject("Not implemented");
  }

  async subscribeToNewsletter(): Promise<FunctionResult<boolean>> {
    return Promise.reject("Not implemented");
  }

  async sendMessage(): Promise<FunctionResult<boolean>> {
    return Promise.reject("Not implemented");
  }
}
